package pl.decks.personal.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.RowScope
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.gap
import pl.decks.personal.styles.SiteLayout

@Composable
fun LeadingIconRow(
    icon: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable RowScope.() -> Unit,
) = Row(
    modifier = Modifier.gap(SiteLayout.Space.Relative.XSmall).then(modifier),
    verticalAlignment = Alignment.CenterVertically,
) {
    icon()
    content()
}

@Composable
fun TrailingIconRow(
    icon: @Composable () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable RowScope.() -> Unit,
) = Row(
    modifier = Modifier.gap(SiteLayout.Space.Relative.XSmall).then(modifier),
    verticalAlignment = Alignment.CenterVertically,
) {
    content()
    icon()
}
